/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/style-prop-object */
import React, { useEffect, useState, useCallback } from "react";
import { Avatar, ListItem, ListItemText, Card } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import app from "../../services/base.js";
import "./ChatBio.scss";
import close from "../../assets/close.png";
import arrowleft from "../../assets/arrowLeft.png";
import banner from "../../assets/banner.png";
import IconButton from "@material-ui/core/IconButton";
import classNames from "classnames";
import { maxTextLength } from "../../utils/formatters.js";
import Lightbox from "react-image-lightbox";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "react-image-lightbox/style.css";
import Skeleton from "react-loading-skeleton";
import api from "../../services/api.js";

const styles = () => ({
  colorDefault: {
    backgroundColor: "#51A6FF",
    width: "3.5rem",
    height: "3.5rem",
  },
  listItem: {
    position: "unset",
  },
  title: {
    color: "#303030",
    fontSize: "1.4rem",
  },
  titleHeader: {
    marginLeft: 10,
    color: "#303030",
    fontSize: "1.4rem",
    height: 100,
    alignItems: "center",
    display: "flex",
  },
  chatTitleHeader: {
    display: "flex",
    alignItems: "center",
    background: "#EEE",
    position: "absolute",
    width: "inherit",
  },
  subTitle: {
    marginTop: 1,
    color: "#303030",
    fontSize: "1.4rem",
  },
  section: {
    margin: 10,
  },
  sectionDivider: {
    borderTop: "5px solid #6464642e",
  },
  chatBio: {
    display: "flex",
    alignItems: "center",
    marginTop: "2rem",
  },
  fixedMessage: {
    background: "#fff",
    marginTop: "2rem",
    maxHeight: "100%",
    marginRight: 3,
  },
  header: {
    color: "#303030",
    fontSize: "1.6rem",
    marginLeft: 14,
  },
  legend: {
    color: "#404040",
    fontSize: "1.3rem",
    fontWeight: 400,
  },
  divMessage: {
    padding: 12,
    cursor: "pointer",
  },
  labelMessage: {
    color: "#404040",
    border: "1px #fff solid",
    backgroundColor: "#F4F4F4",
    padding: 11,
    fontSize: 18,
    borderLeftColor: "#071FC1",
    borderLeftWidth: 6,
    borderEndStartRadius: 6,
    borderStartStartRadius: 6,
  },
  primary: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    color: "#303030",
  },
  secondary: {
    color: "#303030",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 13,
  },
});
const ChatBio = ({
  closedBio,
  selectedConversation,
  classes,
  isActive,
  currentUser,
  sendMessage,
  sendGroupMessage,
}) => {
  const userId = currentUser.id;
  const [targetConversation, setTargetConversation] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [showMoreMidia, setshowMoreMidia] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentSession, setCurrentSession] = useState(0);
  const [showDescription, setShowDescription] = useState(false);
  const [midias, setMidias] = useState([]);
  const [docs, setDocs] = useState([]);
  const [links, setLinks] = useState([]);
  const [validLinkPreview, setValidLinkPreview] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingMidias, setloadingMidias] = useState(false);

  let chatBioContents = null;
  const className = classNames("chat-bio", {
    active: isActive,
    ...classes.sectionDivider,
  });

  const loadingStorage = useCallback(async () => {
    setloadingMidias(true);
    try {
      const msgs = await app
        .firestore()
        .collection("connections")
        .doc(selectedConversation.id)
        .collection("chat")
        .orderBy("createdAt", "desc")
        .get();
      const formatedMsgs = msgs.docs.map((doc) => doc.data());

      setMidias(
        formatedMsgs
          .filter(
            (midia) =>
              midia.attachment &&
              midia.attachment.type &&
              midia.attachment.name &&
              !midia.attachment.name.includes("pdf") &&
              (isVideo(midia.attachment.type) || isImage(midia.attachment.type))
          )
          .map((midia) => (
            <li style={{ marginTop: 30 }}>
              {contentTypePrev(midia.attachment)}
            </li>
          ))
      );
      setDocs(
        formatedMsgs
          .filter(
            (midia) =>
              midia.attachment &&
              midia.attachment.type &&
              !isVideo(midia.attachment.type) &&
              !isImage(midia.attachment.type)
          )
          .map((midia) => (
            <li style={{ marginTop: 30 }}>
              {contentTypePrev(midia.attachment)}
            </li>
          ))
      );

      let linksFromMessages = formatedMsgs
        .filter((msg) => {
          return checkIfExistsURL(msg.text) != null && !msg.fileAttachment;
        })
        .map((msg) => checkIfExistsURL(msg.text))
        .map((link) => link[0]);

      getPreview(linksFromMessages);
      setloadingMidias(false);
    } catch (e) {
      setloadingMidias(false);
    }
  }, [selectedConversation]);

  useEffect(() => {
    if (selectedConversation) {
      setLoading(true);
      if (selectedConversation.chatType !== "GroupChat") {
        getUserInfo();
      } else {
        getGroupInfo();
      }
    }
  }, [selectedConversation]);

  async function getUserInfo() {
    const targetUserId =
      selectedConversation.sender === userId
        ? selectedConversation.receiver
        : selectedConversation.sender;

    const user = await app
      .firestore()
      .collection("users")
      .doc(targetUserId)
      .get();

    const getCommonGroups = await app
      .firestore()
      .collection("connections")
      .where("users", "array-contains", userId)
      .get();

    setTargetConversation({
      ...user.data(),
      commonGroups: getCommonGroups.docs
        .filter(
          (doc) =>
            doc.data().chatType === "GroupChat" &&
            doc.data().users.includes(targetUserId)
        )
        .map((group) => group.data()),
      title: `${user.data().firstName} ${user.data().lastName}`,
      description: user.data().bio,
      tags: user.data().tags,
    });
    setLoading(false);
  }
  async function getGroupInfo() {
    const event = await app
      .firestore()
      .collection("events")
      .doc(selectedConversation.eventId)
      .get();

    const members = event
      .data()
      .attenders.filter((attender) =>
        selectedConversation.users.includes(attender.id)
      );
    setTargetConversation({
      ...selectedConversation.groupInfo,
      tags: selectedConversation.groupInfo.groupChatTags,
      members,
      id: selectedConversation.id,
    });
    setLoading(false);
  }
  function contentTypePrev(attachment) {
    switch (attachment.contentType) {
      case "image":
        return (
          <>
            <img
              className={"bio-img"}
              onClick={() => setIsOpen(true)}
              src={attachment.remoteUrl}
              alt="Imagem enviada"
            />
            {isOpen && (
              <Lightbox
                mainSrc={attachment.remoteUrl}
                onCloseRequest={() => setIsOpen(false)}
              />
            )}
          </>
        );

      case "video":
        return (
          <video controls className={"bio-video"}>
            <source src={attachment.remoteUrl} />
            Oops! Seu navegador não tem suporte a vídeos!
          </video>
        );
      case "docs":
        return (
          <object
            width="150"
            height="150"
            data={attachment.remoteUrl}
            className={"bio-object"}
          >
            Oops! Seu navegador não tem suporte a visualização de documentos!
          </object>
        );
      default:
        break;
    }
  }

  function checkIfExistsURL(text) {
    if (!text) {
      return null;
    }
    const url = text.match(
      // eslint-disable-next-line no-useless-escape
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
    );

    return url;
  }
  function isVideo(contentType) {
    return contentType.includes("video");
  }
  function isImage(contentType) {
    return contentType.includes("image");
  }

  function renderInfo(lastAttachments) {
    return (
      <>
        <div className={classes.chatTitleHeader}>
          <div className="return-button" onClick={() => closedBio()}>
            <IconButton color="primary">
              <img src={close} height={15} width={15} alt="Voltar" />
            </IconButton>
          </div>
          <span className={classes.titleHeader}>
            {selectedConversation
              ? `Mais informações de ${targetConversation.title || ""}`
              : "Informações do grupo"}
          </span>
        </div>

        <div style={{ marginTop: 110 }}>
          <div className={classes.section}>
            <div className={classes.title}>
              <h3> Descrição</h3>
            </div>
            <div className={classes.subTitle}>
              {targetConversation.description &&
              targetConversation.description.length > 0 ? (
                <>
                  {!showDescription &&
                  targetConversation.description.length > 75 ? (
                    <span style={{ marginLeft: 10 }}>
                      {maxTextLength(targetConversation.description, 75)}
                      <span
                        onClick={() => setShowDescription(true)}
                        style={{
                          color: "#1462b2",
                          cursor: "pointer",
                          marginLeft: 10,
                        }}
                      >
                        Ver mais
                      </span>
                    </span>
                  ) : (
                    <span style={{ marginLeft: 10 }}>
                      {targetConversation.description}
                      {targetConversation.description.length > 75 ? (
                        <span
                          onClick={() => setShowDescription(false)}
                          style={{
                            color: "#1462b2",
                            cursor: "pointer",
                            marginLeft: 10,
                          }}
                        >
                          Esconder
                        </span>
                      ) : null}
                    </span>
                  )}
                </>
              ) : (
                <span style={{ marginLeft: 10 }}>Sem descrição</span>
              )}
            </div>
          </div>
          <div className={classes.sectionDivider}></div>
          <div className={classes.section}>
            <div className={classes.title}>
              <h3> Tags</h3>
            </div>
            {targetConversation.tags && targetConversation.tags.length > 0 ? (
              <div style={{ flexDirection: "row" }}>
                {targetConversation.tags.map((tag) => {
                  return (
                    <div className="tag-button">
                      <p>{tag}</p>
                    </div>
                  );
                })}
              </div>
            ) : (
              <span style={{ marginLeft: 10 }}>Sem tags</span>
            )}
          </div>
          <div className={classes.sectionDivider}></div>
          {lastAttachments && lastAttachments.length > 0 ? (
            <div className={classes.section}>
              <div
                className={classes.title}
                style={{ display: "flex", maxWidth: 800 }}
              >
                <h3 style={{ flex: 1 }}>Mídias, links e docs </h3>
                {lastAttachments.length > 2 ? (
                  !showMoreMidia ? (
                    <h4
                      style={{ textAlign: "right", cursor: "pointer" }}
                      // onClick={() => setshowMoreMidia(true)}
                      onClick={() => {
                        loadingStorage();
                        setCurrentSession(1);
                      }}
                    >
                      Ver mais
                    </h4>
                  ) : (
                    <h4
                      style={{ textAlign: "right", cursor: "pointer" }}
                      onClick={() => setshowMoreMidia(false)}
                    >
                      Ver menos
                    </h4>
                  )
                ) : null}
              </div>

              {!showMoreMidia ? (
                <div className={classes.subTitle}>
                  <ul style={{ display: "flex", listStyleType: "none" }}>
                    {lastAttachments.slice(0, 3).map((attachment) => {
                      return <li>{contentTypePrev(attachment)}</li>;
                    })}
                  </ul>
                </div>
              ) : (
                <div className={classes.subTitle}>
                  <ul
                    style={{
                      display: "flex",
                      listStyleType: "none",
                      flexWrap: "wrap",
                    }}
                  >
                    {lastAttachments.map((attachment) => {
                      return <li>{contentTypePrev(attachment)}</li>;
                    })}
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <div className={classes.section}>
              <div
                className={classes.title}
                style={{ display: "flex", maxWidth: 800 }}
              >
                <h3 style={{ flex: 1 }}>Mídias, links e docs </h3>
              </div>
              <span style={{ marginLeft: 10 }}>
                Sem Mídias, links e documentos
              </span>
            </div>
          )}
          <div className={classes.sectionDivider}></div>
          {targetConversation.members && targetConversation.members.length > 0 && (
            <div className={classes.section}>
              <div className={classes.title}>
                <h3> Membros</h3>
              </div>
              {targetConversation.members.map((member) => {
                return (
                  <div key={member.id}>
                    <ListItem
                      className={className}
                      onClick={() =>
                        member.id !== currentUser.id
                          ? sendMessage(member.id)
                          : {}
                      }
                    >
                      <Avatar
                        className={classes.colorDefault}
                        src={member.photoURL}
                      />
                      <ListItemText
                        classes={{
                          primary: classes.primary,
                          secondary: classes.secondary,
                        }}
                        primary={
                          member.id !== currentUser.id
                            ? `${member.firstName} ${member.lastName}`
                            : "Você"
                        }
                        secondary={maxTextLength(member.bio, 25)}
                      />
                    </ListItem>
                    <div style={{ borderTop: "2px solid #f0f0f0" }}></div>
                  </div>
                );
              })}
            </div>
          )}
          {targetConversation.commonGroups &&
            targetConversation.commonGroups.length > 0 && (
              <div className={classes.section}>
                <div className={classes.title}>
                  <h3> Grupos em comum</h3>
                </div>

                {targetConversation.commonGroups.map((group) => {
                  return (
                    <div key={group.id}>
                      <ListItem
                        className={className}
                        onClick={() =>
                          group.id !== currentUser.id
                            ? sendGroupMessage(group.id)
                            : {}
                        }
                      >
                        <Avatar
                          className={classes.colorDefault}
                          src={group.groupInfo}
                        />
                        <ListItemText
                          classes={{
                            primary: classes.primary,
                            secondary: classes.secondary,
                          }}
                          primary={group.groupInfo.title}
                          secondary={maxTextLength(
                            group.groupInfo.description,
                            25
                          )}
                        />
                      </ListItem>
                      <div style={{ borderTop: "2px solid #f0f0f0" }}></div>
                    </div>
                  );
                })}
              </div>
            )}
        </div>
      </>
    );
  }
  function renderLoading() {
    return (
      <>
        <div className={classes.chatTitleHeader}>
          <div className="return-button" onClick={() => closedBio()}>
            <IconButton color="primary">
              <img src={close} height={15} width={15} alt="Voltar" />
            </IconButton>
          </div>
          <span className={classes.titleHeader}>
            {selectedConversation
              ? `Mais informações de ${targetConversation.title || ""}`
              : "Informações do grupo"}
          </span>
        </div>

        <div style={{ marginTop: 110 }}>
          <div className={classes.section}>
            <div className={classes.title}>
              <h3> Descrição</h3>
            </div>
            <div className={classes.subTitle}>
              <Skeleton style={{ background: "#EEEEEE" }} />
            </div>
          </div>

          <div className={classes.section}>
            <div className={classes.title}>
              <h3> Tags</h3>
            </div>
            <Skeleton style={{ background: "#EEEEEE" }} />
          </div>
          <div className={classes.section}>
            <div
              className={classes.title}
              style={{ display: "flex", maxWidth: 800 }}
            >
              <h3 style={{ flex: 1 }}>Mídias, links e docs </h3>
            </div>
            <ul
              style={{
                display: "flex",
                listStyleType: "none",
                flexDirection: "row",
              }}
            >
              {[1, 2, 3].map((_, index) => (
                <li style={{ margin: 10, listStyleType: "none" }}>
                  <Skeleton key={index} width={90} height={70} />
                </li>
              ))}
            </ul>
          </div>

          <div className={classes.section}>
            <div className={classes.title}>
              <h3>
                {selectedConversation.chatType !== "GroupChat"
                  ? " Grupos em comum"
                  : " Membros"}
              </h3>
            </div>
            <ul
              style={{
                display: "flex",
                listStyleType: "none",
                flexDirection: "column",
              }}
            >
              {[1, 2, 3].map((_, index) => (
                <li
                  style={{
                    margin: 10,
                    listStyleType: "none",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Skeleton key={index} width={40} height={40} />
                  <div
                    style={{
                      margin: 10,
                      listStyleType: "none",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Skeleton key={index} width={90} />
                    <Skeleton key={index} width={90} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  }
  async function getPreview(previewLinks) {
    setLoadingPreview(true);
    await api
      .get(`/getLinksPreviews/`, { params: { links: previewLinks } })
      .then((result) => {
        setValidLinkPreview(
          result.data.map((preview) => formattedData(preview))
        );
        setLoadingPreview(false);
      })
      .catch((e) => {
        setLoadingPreview(false);
      });
  }
  function formattedData(data) {
    return {
      url: data.url,
      isUri: true,
      linkTitle: data.title ? data.title : undefined,
      linkDesc: data.description ? data.description : undefined,
      linkImg:
        data.images && data.images.length > 0
          ? data.images.find((element) => {
              return (
                element.includes(".png") ||
                element.includes(".jpg") ||
                element.includes(".jpeg")
              );
            })
          : undefined,
      linkFavicon:
        data.favicons && data.favicons.length > 0
          ? data.favicons[data.favicons.length - 1]
          : undefined,
    };
  }
  function renderMidias() {
    return (
      <>
        <div className={classes.chatTitleHeader}>
          <div
            className="return-button-midias"
            onClick={() => setCurrentSession(0)}
          >
            <IconButton color="primary">
              <img src={arrowleft} height={15} width={15} alt="Voltar" />
            </IconButton>
          </div>
          <span className={classes.titleHeader}></span>
        </div>
        <div style={{ marginTop: 70 }}>
          <Tabs>
            <TabList
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                background: "#eeeeee",
              }}
            >
              <Tab className={"tab-style"}>Mídias</Tab>
              <Tab className={"tab-style"}>Links</Tab>
              <Tab className={"tab-style"}>Docs</Tab>
            </TabList>

            <TabPanel>
              <ul style={{ display: "flex", listStyleType: "none" }}>
                {!loadingMidias ? (
                  <>
                    {midias && midias.length > 0 ? (
                      midias
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <span>
                          Nenhum video ou imagens foram compartilhados
                        </span>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {[1, 2, 3].map((_, index) => (
                      <li style={{ margin: 10 }}>
                        <Skeleton key={index} width={90} height={70} />
                      </li>
                    ))}
                  </>
                )}
              </ul>
            </TabPanel>
            <TabPanel>
              <ul
                style={{
                  display: "flex",
                  listStyleType: "none",
                  flexDirection: "column",
                }}
              >
                <>
                  {loadingPreview ? (
                    <li style={{ margin: 10, marginTop: 40 }}>
                      <Skeleton width={288} height={204} />
                    </li>
                  ) : (
                    <>
                      {validLinkPreview && validLinkPreview.length > 0 ? (
                        validLinkPreview.map((linkPreview, index) => {
                          return (
                            <li
                              className={"links-container"}
                              style={index === 0 ? { marginTop: 40 } : {}}
                              title={linkPreview.url}
                            >
                              <img
                                src={linkPreview.linkImg}
                                style={{ height: 150, width: "auto" }}
                              />
                              <div style={{ margin: 5 }}>
                                {linkPreview.linkTitle && (
                                  <div>
                                    <strong className="title">
                                      {linkPreview.linkTitle}
                                    </strong>
                                  </div>
                                )}
                                {linkPreview.linkDesc && (
                                  <div>
                                    <span className="subtitle">
                                      {linkPreview.linkDesc}
                                    </span>
                                  </div>
                                )}
                                <div>
                                  <a
                                    href={linkPreview.url}
                                    className="url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {linkPreview.url}
                                  </a>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <span>Nenhum link foi compartilhado</span>
                        </div>
                      )}
                    </>
                  )}
                </>
              </ul>
            </TabPanel>
            <TabPanel>
              <ul style={{ display: "flex", listStyleType: "none" }}>
                {!loadingMidias ? (
                  <>
                    {docs && docs.length > 0 ? (
                      docs
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <span>Nenhum documento foi compartilhado</span>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {[1, 2, 3].map((_, index) => (
                      <li style={{ margin: 10 }}>
                        <Skeleton key={index} width={90} height={70} />
                      </li>
                    ))}
                  </>
                )}
              </ul>
            </TabPanel>
          </Tabs>
        </div>
      </>
    );
  }

  if (selectedConversation) {
    let lastAttachments = selectedConversation.lastAttachments
      ? selectedConversation.lastAttachments.filter(
          (attach) =>
            !(
              attach &&
              Object.keys(attach).length === 0 &&
              Object.getPrototypeOf(attach) === Object.prototype
            )
        )
      : [];
    chatBioContents = (
      <div id="chat-bio" className="chat-bio-container">
        {loading ? (
          <>{renderLoading()}</>
        ) : (
          <>
            {currentSession === 0 ? (
              <>{renderInfo(lastAttachments)}</>
            ) : (
              <>{renderMidias(lastAttachments)}</>
            )}
          </>
        )}
      </div>
    );
  }

  return <>{chatBioContents}</>;
};

export default withStyles(styles)(ChatBio);
